import request from '../utils/request'
import QS from "qs";

export function getOrderList (data) {
  return request({
    url: '/api/user/order',
    method:'get',
    params:data,
  })
}
export function orderListDes (id) {
  return request({
    url: `/api/user/order/${id}`,
    method: 'get',
  })
}
export function orderOfflineQrcode (id) {
  return request({
    url: `/api/user/order/${id}/offline-qrcode`,
    method: 'get',
  })
}
export function orderDel (id) {
  return request({
    url: `api/user/order/${id}/cancel`,
    method: 'post'
  })
}

export function takeGood (id) {
  return request({
    url: `/api/user/order/${id}/take-goods`,
    method: 'put'
  })
}
// /api/user/wallet/recharge
export function cartOrderSubmit (data) { // 购物车提交订单
  return request({
    url: '/api/cart/order',
    method: 'post',
    data:QS.stringify(data),
  })
}
export function orderComment (id,data) { // 订单评价
  return request({
    url: `/api/user/order/${id}/comment`,
    method: 'post',
    data:QS.stringify(data),
  })
}

export function orderRefund (id,data) { // 订单退款
  return request({
    url: `/api/user/order/${id}/refund`,
    method: 'post',
    data:QS.stringify(data),
  })
}
